/**
 * Performance Review domain types
 * Mirrors the backend `PerformanceReviewTemplateResponse` and
 * `PerformanceReviewInstanceResponse` DTOs.
 */

export enum ReviewStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export type ReviewFieldType = 'rating' | 'textarea' | 'text';

export interface ReviewField {
  id: string;
  type: ReviewFieldType;
  label: string;
  description?: string;
  required?: boolean;
  placeholder?: string;
  scaleMin?: number;
  scaleMax?: number;
  value?: string | number;
  /** Set by the content parser for field types this client does not know how to edit. */
  readOnly?: boolean;
}

export interface ReviewSection {
  id: string;
  title: string;
  description?: string;
  fields: ReviewField[];
}

export interface ReviewContent {
  version: 1;
  sections: ReviewSection[];
}

/**
 * Review/template content as it arrives from the backend, where it is stored as
 * a free-form JSON column. Always narrow it through `parseReviewContent` before
 * rendering.
 */
export type RawReviewContent = unknown;

export interface PerformanceReviewTemplate {
  id: string;
  organizationId: string;
  name: string;
  templateContent: RawReviewContent;
  createdById: string;
  createdByName?: string;
  baseTemplate: boolean;
  created: string;
  updated: string;
}

export interface PerformanceReview {
  id: string;
  organizationId: string;
  templateId: string;
  templateName?: string;
  memberId: string;
  memberName?: string;
  reviewerId: string;
  reviewerName?: string;
  reviewContent: RawReviewContent;
  status: ReviewStatus;
  publishedAt?: string;
  created: string;
  updated: string;
}
